module.exports = __webpack_public_path__ + "img/국민카드.9558e54c.png";